import store from '@/store'
import { BizBrowserFunctionNames } from './bizBrowserFunctionNames'
import { UPDATE_BIZ_BROWSER_STATE } from '@/store/actions'
import { openMessage } from '@/utils/helpers'
import { IMessageType } from 'smartbarcode-web-core/src/utils/types'
import emitter from '@/utils/mitt'
import { parseRfidScanResult, RfidScanParsedResult } from './rfidScanResultHandler'
import i18n from '@/i18n/i18n'

export interface IExposedForBizBrowser {
  alertMessage: (message: string) => void
  toastMessage: (message: string, type?: IMessageType) => void
  sendStateToBizBrowser: () => void
  receiveScannedResults: (scannedResultsJson: string) => void
  updateRfidConnectionStatus: (isConnected: '0' | '1', isDeviceScanning: '0' | '1') => void
  updateRfidPowerLevel: (rfidPowerLevel: string) => void
}

/* All response message args must be string */

export async function alertMessage(messageKey: string): Promise<void> {
  window.alert(i18n.global.t(messageKey)) // mainly for debug
}

export async function toastMessage(messageKey: string, type?: IMessageType): Promise<void> {
  openMessage(i18n.global.t(messageKey), type ?? 'info')
}

export async function sendStateToBizBrowser(): Promise<void> {
  const bizBrowserState = store.getters.bizBrowserState

  // eslint-disable-next-line no-unused-expressions
  window.bizsd?.postMessage(`${BizBrowserFunctionNames.SEND_STATE}::${JSON.stringify(bizBrowserState)}`)
}

export async function updateRfidConnectionStatus(isConnected: '0' | '1', isDeviceScanning: '0' | '1'): Promise<void> {
  store.dispatch(UPDATE_BIZ_BROWSER_STATE, {
    isConnectedWithRfidDevice: isConnected === '1',
    isDeviceScanning: isDeviceScanning === '1',
  })
}

export async function updateRfidPowerLevel(rfidPowerLevel: string): Promise<void> {
  store.dispatch(UPDATE_BIZ_BROWSER_STATE, {
    rfidPowerLevel: parseInt(rfidPowerLevel),
  })
}

export async function receiveScannedResults(scannedResultsJson: string): Promise<void> {
  try {
    const rawResults: RfidScanParsedResult[] = JSON.parse(scannedResultsJson)
    const parsedResults = rawResults.map((rawResult) => parseRfidScanResult(rawResult))
    emitter.emit('rfid:scanned', parsedResults)
  } catch (error) {
    openMessage('Error parsing RFID scan result: ' + error, 'error')
  }
}
